const selectors = {
  items: "[data-role='grid-hover-item']",
  title: "[data-role='grid-hover-item-title']",
  layer: "[data-role='grid-hover-item-layer']",
  image: "[data-role='grid-hover-item-image']",
};

const items = document.querySelectorAll<HTMLElement>(selectors.items);
items.forEach((item) => {
  const image = item.querySelector(selectors.image);

  if (!image) {
    return;
  }

  item.addEventListener("mouseenter", () => {
    image.classList.toggle("lg:grayscale");
    image.classList.toggle("lg:opacity-40");
  });

  item.addEventListener("touchstart", () => {
    image.classList.toggle("lg:grayscale");
    image.classList.toggle("lg:opacity-40");
  });

  item.addEventListener("mouseleave", () => {
    image.classList.toggle("lg:grayscale");
    image.classList.toggle("lg:opacity-40");
  });

  item.addEventListener("touchend", () => {
    image.classList.toggle("lg:grayscale");
    image.classList.toggle("lg:opacity-40");
  });
});
